const URL = "https://backend.onapau.cat:9989";

export default URL;